import ReactMarkdown, { Components } from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { components } from '../../../utils/markdown';

type CustomMarkdownProps = { className?: string; children: string | null | undefined };

const CustomMarkdown = ({ children, className }: CustomMarkdownProps) => (
  <div className={className}>
    <ReactMarkdown components={components as Components} remarkPlugins={[remarkGfm]}>
      {children}
    </ReactMarkdown>
  </div>
);

export default CustomMarkdown;
